import * as React from 'react';
import Emply from 'antd/lib/empty';
import { Route, Switch } from 'react-router-dom';
import { Transition } from 'react-transition-group';
import { IStateApp } from '../Reducers/index';
import { connect } from 'react-redux';

export interface IRoute {
	name: string;
	path: string;
	canWrite?: boolean;
	component: React.ReactElement;
	exact?: boolean;
}

export interface ITransitionProps {
	route: IRoute;
}

const transitionStyles = {
  entering: { opacity: 1 },
  entered:  { opacity: 1 },
  exiting:  { opacity: 0 },
  exited:  { opacity: 0 },
} as any;

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
}

const ReportTransition = (props: ITransitionProps) => {
	const [animate, setAnimate] = React.useState(false);
	const Component = props.route.component as any;
	setTimeout(() => {
		setAnimate(true);
	}, 100);
	return <Transition in={animate} timeout={500}>
		 {(state: any) => (
      <div style={{
        ...defaultStyle,
        ...transitionStyles[state]
      }}>
		{Component}
		</div>)}
	</Transition>;
}

export interface IRoutesProps {
	routes: IRoute[];
	isAdmin?: boolean;
}

const Routes = (props: IRoutesProps) => {
	const routes: IRoute[] = props.routes;
	return <Switch>{routes.filter(r => r.name !== 'var' || (r.name === 'var' && props.isAdmin)).map(r => (
		<Route exact={r.exact} key={r.name} path={r.path} render={() => <ReportTransition route={r} />} />))}
		<Route path="*" render={() => <Emply description="No Encontrado" />} />
	</Switch>
};

const mapProps: any = (state: IStateApp) => ({
	isAdmin: state.session && state.session.account && state.session.account.idProfile === 1
});

export default connect<IRoutesProps>(mapProps)(Routes) as any;
